export default {
    ADS_PUBLICATION_title: "Ads Portals",
    ADS_PUBLICATION_create: "Add a portal",
    ADS_PUBLICATION_add: "Add",
    ADS_PUBLICATION_ftpCreate: "Create a portal",
    ADS_PUBLICATION_confirmCreate: "Add the portal",
    ADS_PUBLICATION_ftpUpdate: "Update the portal",
    ADS_PUBLICATION_apiCreate: "Create an API portal",
    ADS_PUBLICATION_apiUpdate: "Update the API portal",
    ADS_PUBLICATION_fieldApiUsername: "Username",
    ADS_PUBLICATION_fieldApiPassword: "Password",
    ADS_PUBLICATION_confirmUpdate: "Portal update",

    ADS_PUBLICATION_createSuccessTitle: "Notification",
    ADS_PUBLICATION_createSuccessMessage: "New portal has been successfully created",
    ADS_PUBLICATION_createUpdateMessage: "The portal has been successfully updated",
    ADS_PUBLICATION_createDeleteMessage: "The portal has been successfully deleted",
    ADS_PUBLICATION_UpdateCustomerMessage: "Customer group has been successfully updated",
    ADS_PUBLICATION_createCustomerMessage: "Customer group has been successfully created",

    CUSTOMERS_actionFtp: "FTP",
    CUSTOMERS_actionApi: "API",

    ADS_PUBLICATION_columnId: "ID",
    ADS_PUBLICATION_columnLogo: "Logo",
    ADS_PUBLICATION_columnImage: "Image",
    ADS_PUBLICATION_columnName: "Name",
    ADS_PUBLICATION_columnType: "Type",
    ADS_PUBLICATION_columnDescription: "Description",
    ADS_PUBLICATION_columnSerializer: "Serializer",
    ADS_PUBLICATION_columnCode: "Sent code",
    ADS_PUBLICATION_columnSubscription: "Subscription",
    ADS_PUBLICATION_columnNumberOfAds: "No. of ads",
    ADS_PUBLICATION_columnStatus: "Status",
    ADS_PUBLICATION_columnAutoStatus: "Auto broadcasting",
    ADS_PUBLICATION_columnLastSend: "Last send",
    ADS_PUBLICATION_columnStartDate: "Start date",
    ADS_PUBLICATION_columnOnlineSubscription: "Online subscription",
    ADS_PUBLICATION_columnOwner: "Owner",
    ADS_PUBLICATION_columnSubType: "Subtype",
    ADS_PUBLICATION_columnZipCode: "Zip code",
    ADS_PUBLICATION_columnCategory: "Category",
    ADS_PUBLICATION_columnNoOfRooms: "Number of rooms",
    ADS_PUBLICATION_columnPrice: "Price",
    ADS_PUBLICATION_columnMandate: "Mandate",
    ADS_PUBLICATION_columnCreated: "Created on",

    ADS_PUBLICATION_splashScreenTitle: "Create your first ad portal",
    ADS_PUBLICATION_splashScreenDescription: "Create and automate ads...",

    ADS_PUBLICATION_listOfAdsTitle: "List of ad portals",
    ADS_PUBLICATION_listOfAdsDescription: 
    "Here is the list of ad portals available in your account and not activated.",

    ADS_PUBLICATION_newAdsPortalsTitle: "Add an ad portal",
    ADS_PUBLICATION_newAdsPortalsCreate: "Add the ad portal",
    ADS_PUBLICATION_newAdsPortalsUpdate: "Edit the ad portal",
    ADS_PUBLICATION_newAdsPortalsCancel: "Cancel",
    ADS_PUBLICATION_modalUpdateTitle: "Edit an ad portal",

    ADS_PUBLICATION_fieldSiteName: "Site name",
    ADS_PUBLICATION_fieldContactEmail: "Customer service contact email",
    ADS_PUBLICATION_fieldIdentifierSent: "Sent identifier",
    ADS_PUBLICATION_fieldBroadcastStatus: "Automatic broadcasting",
    ADS_PUBLICATION_fieldGroups: "Display the portal in group(s):",

    // FTP form
    ADS_PUBLICATION_fieldLabel: "Label",
    ADS_PUBLICATION_fieldStatus: "Status",
    ADS_PUBLICATION_fieldExportFormat: "File format",
    ADS_PUBLICATION_fieldSerializer: "Serializer (xml,csv)",
    ADS_PUBLICATION_fieldEncoding: "Encoding",
    ADS_PUBLICATION_fieldExportType: "Export type",
    ADS_PUBLICATION_fieldSiteIdentifier: "Site identifier",
    ADS_PUBLICATION_fieldAffiliateIdentifier: "Affiliate identifier",
    ADS_PUBLICATION_fieldDescription: "Description",
    ADS_PUBLICATION_fieldLogo: "Logo",
    ADS_PUBLICATION_fieldQuota: "Quota (Transellis XML)",
    ADS_PUBLICATION_fieldFtpHost: "FTP Host (server)",
    ADS_PUBLICATION_fieldFtpUsername: "FTP Username",
    ADS_PUBLICATION_fieldFtpPassword: "FTP Password",
    ADS_PUBLICATION_fieldFtpRemoteDirectory: "FTP Remote directory",
    ADS_PUBLICATION_fieldFtpPort: "FTP Port",
    ADS_PUBLICATION_fieldFtpMode: "FTP Passive mode",
    ADS_PUBLICATION_fieldFtpModeSsl: "FTP SSL Mode (FTPS)",

    // New translations for FTP and export options
    ADS_PUBLICATION_fieldFtpPassiveMode: 
    "Passive mode (by default, passive mode should be enabled)",
    ADS_PUBLICATION_fieldFtpSslMode: "SSL Mode (FTPS)",
    ADS_PUBLICATION_fieldAutoExport: "Export automatically",
    ADS_PUBLICATION_fieldMutualizedExport: 
    "Mutualized export (shared sending across multiple companies)",
    ADS_PUBLICATION_fieldEditableContacts: "Editable contacts",
    ADS_PUBLICATION_fieldEditableGroups: "Display the portal on the group(s)",
    
    // Contact management translations
    ADS_PUBLICATION_fieldContactManagement: "Contact management",
    ADS_PUBLICATION_contactManagementTooltip: "Some websites let you assign a contact to a listing "
        + "with their phone and email. You can choose from the options below.",
    ADS_PUBLICATION_contactSourceNegotiator: "Use the advisor's contact details",
    ADS_PUBLICATION_contactSourceAgency: "Use the point of sale's contact details",
    ADS_PUBLICATION_contactSourceCompany: "Use the company's contact details",

    ADS_PUBLICATION_statusActive: "Active",
    ADS_PUBLICATION_statusInactive: "Inactive",

    ADS_PUBLICATION_statusZip: "Zip",
    ADS_PUBLICATION_statusText: "Text",
    ADS_PUBLICATION_statusUtf8: "UTF-8",
    ADS_PUBLICATION_statusLatin: "Latin",

    ADS_PUBLICATION_formSeloger: "Seloger",
    ADS_PUBLICATION_formPaid: "Paid",
    ADS_PUBLICATION_formSiteNameValue: "Se loger",
    ADS_PUBLICATION_formContactEmailLabel: "Customer service contact email",
    ADS_PUBLICATION_formContactEmailValue: "support@seloger.com",
    ADS_PUBLICATION_formDescriptionValue: "National real estate ad site",

    ADS_PUBLICATION_actionActivetor: "Activate",
    ADS_PUBLICATION_actionActivetorMessage: 
    "Are you sure you want to activate this ad portal?",
    ADS_PUBLICATION_actionDeactivate: "Deactivate",
    ADS_PUBLICATION_actionDeactivateMessage: 
    "Are you sure you want to deactivate this ad portal?",
    ADS_PUBLICATION_actionModify: "Modify",
    ADS_PUBLICATION_actionDeleteMessage: 
    "Are you sure you want to delete the broadcast?",
    ADS_PUBLICATION_actionOk: "OK",
    ADS_PUBLICATION_actionUpdateMessage: "You must provide the sent identifier",
    
    ADS_PUBLICATION_deletedSuccessfully: "Ad portal has been successfully deleted",
    ADS_PUBLICATION_updatedSuccessfully: "Ad portal has been successfully updated",
    ADS_PUBLICATION_createdSuccessfully: "Ad portal has been successfully updated",

    ADS_PUBLICATION_firstGroup: "Display the portal in group(s)",
    ADS_PUBLICATION_GroupOne: "Frédéric Eppler - eppler@transellis (Central agency)",
    ADS_PUBLICATION_GroupTwo: "Frédéric Eppler - contact@transellis (Central agency)",

    ADS_PUBLICATION_imageAlt: "Image",

    ADS_PUBLICATION_listOfAdsLogTitle: "Se Loger Ads",
    ADS_PUBLICATION_annonces_name: "Ads",
    ADS_PUBLICATION_actionDelete: "Delete",
    ADS_PUBLICATION_deleteConfirm: "Are you sure you want to delete this ad portal?",
    ADS_PUBLICATION_deleteImageConfirm: "Are you sure you want to delete this image?",
    ADS_PUBLICATION_passiveMode: "Passive",
    ADS_PUBLICATION_activeMode: "Active",
    ADS_PUBLICATION_fieldPublishSoldAds: "Publish sold listings",
    ADS_PUBLICATION_labelShowSoldAds: "Afficher les annonces vendues",
    ADS_PUBLICATION_actionGroups: "Groups",
    ADS_PUBLICATION_columnAssign: "Assign",
    ADS_PUBLICATION_columnAssigned: "Assigned",
    ADS_PUBLICATION_assignedNo: "Not assigned",
    ADS_PUBLICATION_filterAssigned: "Assignment",
    ADS_PUBLICATION_columnCompany: "Owner name",
    ADS_PUBLICATION_columnGroups: "Selected group",
    ADS_PUBLICATION_filterStatus: "Status",
    // eslint-disable-next-line max-len
    ADS_PUBLICATION_groupsHint: "If no group is checked, everyone sees the portal. As soon as at least one group is checked, only the checked groups see it.",

    // Setup gateway (per-user portal activation)
    SETUP_GATEWAY_title: "Per-user setup",
    // eslint-disable-next-line max-len
    SETUP_GATEWAY_hint: "Activate this portal for each user of a group with their own credentials.",
    SETUP_GATEWAY_group: "Group",
    SETUP_GATEWAY_noGroup: "No group is attributed to this portal.",
    SETUP_GATEWAY_empty: "No setup for this group.",
    SETUP_GATEWAY_loading: "Loading…",
    SETUP_GATEWAY_colUser: "User",
    SETUP_GATEWAY_colCode: "Sent code",
    SETUP_GATEWAY_colUsername: "Username",
    SETUP_GATEWAY_colAuto: "Auto broadcasting",
    SETUP_GATEWAY_addTitle: "Add a setup",
    SETUP_GATEWAY_editTitle: "Edit the setup",
    SETUP_GATEWAY_add: "Add",
    SETUP_GATEWAY_userSearch: "Search a user",
    SETUP_GATEWAY_userSelect: "Select a user",
    SETUP_GATEWAY_errorNoUser: "Select a user",
    SETUP_GATEWAY_deleteConfirm: "Are you sure you want to delete this setup ?",

    // Sale point settings (customers list -> associated portals)
    SALE_POINT_colCompany: "Company",
    SALE_POINT_tabPortals: "Portals",
    SALE_POINT_tabUsers: "Users",
    SALE_POINT_membersEmpty: "No active user",
    SALE_POINT_colOwner: "Owner name",
    SALE_POINT_colEmail: "Email",
    SALE_POINT_colAddress: "Address",
    SALE_POINT_colGroup: "Group",
    SALE_POINT_colStatus: "Status",
    SALE_POINT_colMembers: "Members",
    SALE_POINT_colGroupOwner: "Owner",
    SALE_POINT_colParentGroup: "Parent group",
    SALE_POINT_colPortals: "Portals",
    SALE_POINT_colPortalCount: "Portals count",
    SALE_POINT_filterStatus: "Status",
    SALE_POINT_filterPortals: "Portals",
    SALE_POINT_filterPortalsPlaceholder: "Filter by portal",
    SALE_POINT_statusActive: "Active",
    SALE_POINT_statusInactive: "Inactive",
    SALE_POINT_back: "Back to list",
    SALE_POINT_linkedCustomer: "Linked customer",
    SALE_POINT_group: "Group",
    SALE_POINT_parentGroup: "Parent group",
    SALE_POINT_owner: "Owner",
    SALE_POINT_members: "Members",
    SALE_POINT_memberName: "Name",
    SALE_POINT_memberPhone: "Phone",
    SALE_POINT_memberRoles: "Roles",
    SALE_POINT_portalsTitle: "Associated portals",
    SALE_POINT_portalsEmpty: "No portal configured for this group.",
    SALE_POINT_portalsLoading: "Loading portals…",
    SALE_POINT_portalUsers: "user(s)",
    SALE_POINT_create: "Create a portal",
    SALE_POINT_createTitle: "Configure a portal",
    SALE_POINT_fieldPortal: "Portal",
    SALE_POINT_selectPortal: "Select a portal",
    SALE_POINT_fieldAlias: "Alias",
    SALE_POINT_errorNoPortal: "Select a portal",
    SALE_POINT_pickTitle: "List of ad portals",
    SALE_POINT_pickHint: "Select a portal to configure for this group.",
    SALE_POINT_pickEmpty: "No portal available.",
    SALE_POINT_pickChange: "Change",
    SALE_POINT_colCodeSent: "Sent code",
    SALE_POINT_colAdsCount: "Ads count",
    SALE_POINT_colAutoBroadcast: "Auto broadcast",
    SALE_POINT_colLastExport: "Last export",
    SALE_POINT_colCreatedAt: "Created at",
    SALE_POINT_dateAt: "at",
    SALE_POINT_editPortalTitle: "Edit portal",
    SALE_POINT_fieldIdentifier: "Identifier",
    SALE_POINT_fieldPassword: "Password",
    SALE_POINT_errorNoIdentifier: "Provide the identifier",
    SALE_POINT_colActions: "Actions",
    SALE_POINT_deletePortal: "Delete",
    SALE_POINT_deleteConfirm:
        "Remove the portal “{name}” from this client's account? This action cannot be undone.",
    SALE_POINT_deleteSuccessTitle: "Portal removed",
    SALE_POINT_deleteSuccessMessage: "The portal has been removed from the client's account."
}
